import React from "react";
import { Link } from "react-router-dom";
import { formatArticleDate } from "../utils/helpers";
import { EyeIcon } from "./Icons";

const EpaperModal = ({ pdfArticles, open, onClose, lang }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-black text-3xl z-20 leading-none"
        >
          &times;
        </button>
        <h2 className="text-xl font-bold mb-4 text-red-700 border-b pb-2 flex-shrink-0">
          E-Paper
        </h2>
        {pdfArticles && pdfArticles.length > 0 ? (
          <ul className="divide-y overflow-y-auto">
            {pdfArticles.map((article) => (
              <li
                key={article.id}
                className="py-3 flex justify-between items-center"
              >
                <span
                  className="font-semibold text-blue-800"
                >
                  {formatArticleDate(article)}
                </span>
                <Link
                  to={`/epaper/${article.id}`}
                  onClick={onClose}
                  className="text-blue-600 hover:text-blue-800 p-2 rounded-full hover:bg-gray-100"
                >
                  <EyeIcon />
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className="mt-4">No E-Papers available at the moment.</p>
        )}
      </div>
    </div>
  );
};

export default EpaperModal;
